module.exports = __webpack_public_path__ + "ava.d606b3561eeb43ebef35.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/ava.woff
// module id = ./src/assets/webfonts/ava.woff
// module chunks = styles